import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import initViewportHeight from './utils/viewportHeight'

// Initialize viewport height utility to handle mobile browser address bar
initViewportHeight();

// Prevent text selection globally
document.addEventListener('selectstart', (e) => {
  // Allow selection in inputs, textareas, and contenteditable elements
  if (
    e.target.tagName === 'INPUT' ||
    e.target.tagName === 'TEXTAREA' ||
    e.target.getAttribute('contenteditable') === 'true' ||
    e.target.closest('[contenteditable="true"]') ||
    e.target.tagName === 'PRE' ||
    e.target.tagName === 'CODE'
  ) {
    return true;
  }
  e.preventDefault();
  return false;
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
